export const isLocalEnvironment = () => window.location.host.includes('.local.');
